import React from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input2";

interface ReportActionToolbarProps {
  totalItems: number;
  showingStart: number;
  showingEnd: number;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  children?: React.ReactNode;
}

export const ReportActionToolbar: React.FC<ReportActionToolbarProps> = ({
  totalItems,
  showingStart,
  showingEnd,
  searchTerm,
  onSearchChange,
  searchPlaceholder = "Search...",
  children,
}) => {
  return (
    <div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-3 lg:gap-4 flex-shrink-0 px-1 lg:px-0">
      <div className="flex items-center gap-2">
        <div className="flex-1 lg:flex-none flex items-center justify-between lg:justify-start gap-2 text-xs lg:text-sm font-medium text-[#885ABB] bg-purple-50 px-3 lg:px-4 py-2 rounded-xl border border-purple-100 shadow-sm">
          <span>Total {totalItems}</span>
          <span className="opacity-30">|</span>
          <span>Showing {showingStart}-{showingEnd}</span>
        </div>
        <div className="flex items-center gap-2">
          {children}
        </div>
      </div>

      <div className="relative w-full lg:w-72">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-10 pointer-events-none">
          <Search size={16} />
        </div>
        <Input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 h-10 lg:h-11 bg-white border-gray-200 focus:border-[#885ABB] focus:ring-[#885ABB] rounded-xl shadow-sm text-sm"
        />
      </div>
    </div>
  );
};
